import { render, staticRenderFns } from "./EnsaiosAliquotasLogResultadosIcpIcpCobre.vue?vue&type=template&id=e9e79670&"
import script from "./EnsaiosAliquotasLogResultadosIcpIcpCobre.vue?vue&type=script&lang=ts&"
export * from "./EnsaiosAliquotasLogResultadosIcpIcpCobre.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDataTable,VDivider,VIcon,VRow})
